import { useEffect } from 'react';

const usePreventPullToRefresh = (isModalVisible: boolean) => {
  useEffect(() => {
    const preventPullToRefresh = (event: TouchEvent) => {
      if (window.scrollY === 0 && isModalVisible) {
        event.preventDefault();
      }
    };

    if (isModalVisible) {
      window.addEventListener('touchmove', preventPullToRefresh, {
        passive: false
      });
    }

    return () => {
      window.removeEventListener('touchmove', preventPullToRefresh);
    };
  }, [isModalVisible]);
};

export default usePreventPullToRefresh;
